import { gql } from '@apollo/client';

export const GET_MY_TOOLS_MANAGE = gql`
  query MyToolsManage(
    $limit: Int, 
    $offset: Int, 
    $search: String, 
    $availability: ToolAvailabilityFilterEnum, 
    $sortBy: ToolSortColumnEnum, 
    $sortDirection: SortDirectionEnum
  ) {
    myTools(
      limit: $limit, 
      offset: $offset, 
      search: $search, 
      availability: $availability, 
      includeDisabled: true,
      sortBy: $sortBy, 
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        disabled
        primaryImageUrl
        pricePerDayCents
        city
        postalCode
        availabilityStatus
        viewCount
        favouriteCount
        nextToolBooking {
          id
          status
          fromDate
          toDate
        }
        categories {
          id
          name
          code
        }
      }
      totalCount
    }
  }
`;
